import queryUser from 'shared/graphql/queryUser.gql'
import queryUserWorkspaces from 'shared/graphql/queryUserWorkspaces.gql'
import queryCurrentWorkspace from 'shared/graphql/queryCurrentWorkspace.gql'
import queryWithSubscription from 'shared/apollo/queryWithSubscription'

// @vue/component
const appDataLoader = {
	apollo: {
		$skipAllSubscriptions() {
			return this.documentVisibility === 'hidden'
		},
		user: {
			query: queryUser,
			variables() {
				return {
					userId: this.$auth.userId.value,
				}
			},
			skip() {
				if (this.$auth.loading.value) return true
				if (!this.$auth.isAuthenticated.value) return true
				if (!this.$auth.user.value?.profile?.sub) return true
				return false
			},
			update(data) {
				if (!data) return
				this.$store.user = data.user
			},
		},
		userWorkspaces: queryWithSubscription('userWorkspaces', {
			query: queryUserWorkspaces,
			variables() {
				return {
					userId: this.$auth.userId.value,
					isExtension: this.$store.isExtension,
				}
			},
			skip() {
				if (this.$auth.loading.value) return true
				if (!this.$auth.isAuthenticated.value) return true
				if (!this.$auth.userId.value) return true
				return false
			},
			update(data) {
				if (!data?.userWorkspaces?.length) return
				this.$store.userWorkspaces = data.userWorkspaces
			},
		}),
		currentWorkspace: queryWithSubscription('currentWorkspace', {
			query: queryCurrentWorkspace,
			skip() {
				return Boolean(
					!this.$store.lastSelectedWorkspaceId ||
						this.$auth.loading.value ||
						!this.$auth.isAuthenticated.value
				)
			},
			variables() {
				return {
					id: this.$store.lastSelectedWorkspaceId,
				}
			},
			update(data) {
				if (!data) return
				this.$store.currentWorkspace = data.currentWorkspace
			},
		}),
	},
	mounted() {
		this.$store.queries.user = this.$apollo.queries.user
		this.$store.queries.userWorkspaces = this.$apollo.queries.userWorkspaces
		this.$store.queries.currentWorkspace = this.$apollo.queries.currentWorkspace
	},
}

export default appDataLoader
